module.exports = "/static/assets/b41fa406852eb07c7fb079b0ebec804c.png";